import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import App from './app';
import reducers from './reducers';

// eslint-disable-next-line camelcase
const { initialReduxState = {}, ...props } = window.tesla.App || {};
const store = createStore(reducers, initialReduxState);

ReactDOM.render(<App store={store} {...props} />, document.getElementById('app'));
